import React, { Component } from 'react';
import { Alert, Button, Input, Modal, Tag } from 'antd';
import ReactMarkdown from 'react-markdown';
import { fetchData } from '../../../../lib/apis';
import {
    EXTERNAL_CUSTOMER_API_DOC,
    buildExternalCustomerApiMarkdown
} from './external-api-key-docs';

export default class ExternalApiKeyTab extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            generating: false,
            revoking: false,
            statusData: null,
            revealedKey: '',
            docsVisible: false
        };
    }

    getBaseApiUrl = () => {
        try {
            const origin = window.location.origin;
            return `${origin}/api/v1/ext`;
        } catch (err) {
            return '/api/v1/ext';
        }
    }

    getCurlExamples = () => {
        const baseUrl = this.getBaseApiUrl();
        return {
            list: `curl --request GET \\
  --url '${baseUrl}/customers?page=1&limit=20' \\
  --header 'x-api-key: YOUR_API_KEY'`,
            detail: `curl --request GET \\
  --url '${baseUrl}/customers/contact_123' \\
  --header 'x-api-key: YOUR_API_KEY'`,
            history: `curl --request GET \\
  --url '${baseUrl}/customers/contact_123/messages?limit=20' \\
  --header 'x-api-key: YOUR_API_KEY'`,
            historyLoadMore: `curl --request GET \\
  --url '${baseUrl}/customers/contact_123/messages?limit=20&before_timestamp=1710000000000&before_key=wamid.HBgL...' \\
  --header 'x-api-key: YOUR_API_KEY'`,
            importCallSummary: `curl --request POST \\
  --url '${baseUrl}/customers/contact_123/call-summaries' \\
  --header 'x-api-key: YOUR_API_KEY' \\
  --header 'content-type: application/json' \\
  --data '{
    "external_call_id": "call_20260401_000123",
    "summary_text": "Khách xác nhận đang ở số nhà 123 đường ABC, muốn được gọi lại chốt lịch vào chiều thứ 6 và quan tâm gói niềng răng.",
    "structured_data": {
      "customer": {
        "name": "Nguyễn Thị Lan",
        "phone": "0901234567",
        "email": "lan@example.com",
        "address": "123 đường ABC, phường 5, quận 3, TP.HCM"
      },
      "interests": ["Niềng răng", "Tư vấn nha khoa tổng quát"],
      "budget": "10 triệu",
      "objections": ["Lo ngại chi phí phát sinh"],
      "appointment_date": "Chiều thứ 6 lúc 15h",
      "branch_location": "Công ty Quận 3",
      "notes": "Khách muốn được gọi lại xác nhận lịch"
    },
    "called_at": 1775030280000,
    "agent_name": "Callbot A"
  }'`
        };
    }

    getSwaggerExample = () => {
        const baseUrl = this.getBaseApiUrl();
        return `openapi: 3.0.3
info:
  title: CRM External Customer API
  version: 1.0.0
servers:
  - url: ${baseUrl}
components:
  securitySchemes:
    ApiKeyAuth:
      type: apiKey
      in: header
      name: x-api-key
security:
  - ApiKeyAuth: []
paths:
  /customers:
    get:
      summary: Lấy danh sách khách hàng
      parameters:
        - in: query
          name: page
          schema:
            type: integer
            default: 1
        - in: query
          name: limit
          schema:
            type: integer
            default: 20
        - in: query
          name: search
          schema:
            type: string
        - in: query
          name: updated_from
          schema:
            type: integer
            format: int64
        - in: query
          name: updated_to
          schema:
            type: integer
            format: int64
      responses:
        '200':
          description: Thành công
  /customers/{contact_id}:
    get:
      summary: Lấy chi tiết khách hàng
      parameters:
        - in: path
          name: contact_id
          required: true
          schema:
            type: string
      responses:
        '200':
          description: Thành công
  /customers/{contact_id}/messages:
    get:
      summary: Lấy lịch sử hội thoại của khách hàng
      parameters:
        - in: path
          name: contact_id
          required: true
          schema:
            type: string
        - in: query
          name: limit
          schema:
            type: integer
            default: 20
        - in: query
          name: before_timestamp
          schema:
            type: integer
            format: int64
        - in: query
          name: before_key
          schema:
            type: string
      responses:
        '200':
          description: Thành công
  /customers/{contact_id}/call-summaries:
    post:
      summary: Ghi nhận tóm tắt cuộc gọi từ bên thứ 3
      parameters:
        - in: path
          name: contact_id
          required: true
          schema:
            type: string
      requestBody:
        required: true
        content:
          application/json:
            schema:
              type: object
              anyOf:
                - required:
                    - summary_text
                - required:
                    - structured_data
              properties:
                external_call_id:
                  type: string
                summary_text:
                  type: string
                structured_data:
                  type: object
                called_at:
                  type: integer
                  format: int64
                agent_name:
                  type: string
      responses:
        '200':
          description: Thành công`;
    }

    openDocs = () => {
        this.setState({ docsVisible: true });
    }

    closeDocs = () => {
        this.setState({ docsVisible: false });
    }

    componentDidMount() {
        this.getStatus();
    }

    getStatus = async () => {
        try {
            this.setState({ loading: true });
            const res = await fetchData({ url: 'api/v1/company/external-api-key' });
            this.setState({ loading: false, statusData: res.data || null });
        } catch (err) {
            this.setState({ loading: false });
            this.props.notification({
                title: 'API key bên thứ 3',
                content: err.message || 'Không thể tải trạng thái API key',
                type: 'error'
            });
        }
    }

    handleGenerate = async () => {
        try {
            this.setState({ generating: true });
            const res = await fetchData({
                url: 'api/v1/company/external-api-key/generate',
                method: 'POST',
                data: {}
            });

            this.setState({ generating: false, revealedKey: res.data && res.data.api_key ? res.data.api_key : '' });
            await this.getStatus();

            Modal.success({
                title: 'API key đã được tạo',
                width: 720,
                content: (
                    <div>
                        <p>Hãy lưu lại API key này ngay bây giờ. Hệ thống sẽ không hiển thị lại đầy đủ key sau khi đóng popup.</p>
                        <Input.TextArea value={res.data.api_key} readOnly autoSize={{ minRows: 3, maxRows: 6 }} />
                    </div>
                )
            });
        } catch (err) {
            this.setState({ generating: false });
            this.props.notification({
                title: 'API key bên thứ 3',
                content: err.message || 'Không thể tạo API key',
                type: 'error'
            });
        }
    }

    handleRevoke = () => {
        Modal.confirm({
            title: 'Thu hồi API key',
            content: 'API key hiện tại sẽ không thể dùng để truy xuất dữ liệu nữa. Bạn có chắc muốn tiếp tục?',
            okText: 'Thu hồi',
            cancelText: 'Hủy',
            okType: 'danger',
            onOk: async () => {
                try {
                    this.setState({ revoking: true });
                    await fetchData({
                        url: 'api/v1/company/external-api-key/revoke',
                        method: 'POST',
                        data: {}
                    });
                    this.setState({ revoking: false, revealedKey: '' });
                    await this.getStatus();
                    this.props.notification({
                        title: 'API key bên thứ 3',
                        content: 'Đã thu hồi API key',
                        type: 'success'
                    });
                } catch (err) {
                    this.setState({ revoking: false });
                    this.props.notification({
                        title: 'API key bên thứ 3',
                        content: err.message || 'Không thể thu hồi API key',
                        type: 'error'
                    });
                }
            }
        });
    }

    copyKey = async () => {
        try {
            if (!this.state.revealedKey) return;
            if (navigator.clipboard && navigator.clipboard.writeText) {
                await navigator.clipboard.writeText(this.state.revealedKey);
                this.props.notification({
                    title: 'API key bên thứ 3',
                    content: 'Đã sao chép API key',
                    type: 'success'
                });
                return;
            }
            throw new Error('Clipboard not supported');
        } catch (err) {
            this.props.notification({
                title: 'API key bên thứ 3',
                content: 'Không thể sao chép tự động, vui lòng copy thủ công',
                type: 'warning'
            });
        }
    }

    renderStatus = () => {
        const { statusData } = this.state;
        if (!statusData) {
            return <Alert type="info" message="Công ty này chưa tạo API key cho bên thứ 3." showIcon />;
        }

        return (
            <div style={{ border: '1px solid #f0f0f0', borderRadius: 8, padding: 16, background: '#fff' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', gap: 16, flexWrap: 'wrap' }}>
                    <div>
                        <div style={{ fontSize: 13, color: '#888' }}>Trạng thái</div>
                        <div style={{ marginTop: 4 }}>
                            <Tag color={statusData.status == 1 ? 'green' : 'red'}>
                                {statusData.status == 1 ? 'Đang hoạt động' : 'Đã thu hồi'}
                            </Tag>
                        </div>
                    </div>
                    <div>
                        <div style={{ fontSize: 13, color: '#888' }}>Key prefix</div>
                        <div style={{ marginTop: 4, fontWeight: 600 }}>{statusData.key_prefix || '--'}</div>
                    </div>
                    <div>
                        <div style={{ fontSize: 13, color: '#888' }}>Quyền</div>
                        <div style={{ marginTop: 4 }}>{(statusData.scopes || []).join(', ') || '--'}</div>
                    </div>
                    <div>
                        <div style={{ fontSize: 13, color: '#888' }}>Lần dùng gần nhất</div>
                        <div style={{ marginTop: 4 }}>{statusData.last_used_at ? new Date(statusData.last_used_at).toLocaleString() : 'Chưa có'}</div>
                    </div>
                </div>
            </div>
        );
    }

    render() {
        const { statusData, loading, generating, revoking, revealedKey, docsVisible } = this.state;
        const baseUrl = this.getBaseApiUrl();
        const curlExamples = this.getCurlExamples();
        const swaggerExample = this.getSwaggerExample();
        const markdownDoc = buildExternalCustomerApiMarkdown(baseUrl);
        const docsUpdatedAt = EXTERNAL_CUSTOMER_API_DOC.updatedAt || '';

        return (
            <div style={{ padding: 20, background: '#fafafa' }}>
                <Alert
                    type="warning"
                    showIcon
                    message="API bên thứ 3 dùng x-api-key để truy xuất khách hàng và lịch sử hội thoại của đúng công ty đang chọn."
                    description="API key này chỉ nên cấp cho hệ thống tin cậy. Khi nghi ngờ lộ key, hãy thu hồi và tạo lại ngay."
                    style={{ marginBottom: 16 }}
                />

                {this.renderStatus()}

                <div style={{ marginTop: 16, display: 'flex', gap: 12, flexWrap: 'wrap' }}>
                    <Button type="primary" loading={generating} onClick={this.handleGenerate}>
                        {statusData && statusData.status == 1 ? 'Tạo lại API key' : 'Tạo API key'}
                    </Button>
                    <Button onClick={this.getStatus} loading={loading}>Làm mới</Button>
                    <Button onClick={this.openDocs}>Xem tài liệu tích hợp</Button>
                    {statusData && statusData.status == 1 ? (
                        <Button danger onClick={this.handleRevoke} loading={revoking}>Thu hồi</Button>
                    ) : null}
                </div>

                {revealedKey ? (
                    <div style={{ marginTop: 16 }}>
                        <div style={{ marginBottom: 8, fontWeight: 600 }}>API key mới tạo</div>
                        <Input.TextArea value={revealedKey} readOnly autoSize={{ minRows: 3, maxRows: 5 }} />
                        <div style={{ marginTop: 8 }}>
                            <Button onClick={this.copyKey}>Sao chép key</Button>
                        </div>
                    </div>
                ) : null}

                <div style={{ marginTop: 24, border: '1px dashed #d9d9d9', borderRadius: 8, padding: 16, background: '#fff' }}>
                    <div style={{ fontWeight: 600, marginBottom: 8 }}>Hướng dẫn nhanh cho bên thứ 3</div>
                    <ol style={{ paddingLeft: 18, marginBottom: 12 }}>
                        <li>Lấy API key tại màn hình này và lưu lại an toàn.</li>
                        <li>Gửi key qua header <code>x-api-key</code> ở mọi request.</li>
                        <li>Đồng bộ danh sách qua <code>{baseUrl}/customers</code>.</li>
                        <li>Khi cần xem sâu hơn, gọi detail qua <code>{baseUrl}/customers/:contact_id</code>.</li>
                        <li>Khi cần lịch sử chat, gọi <code>{baseUrl}/customers/:contact_id/messages</code> và dùng cursor để load more.</li>
                        <li>Sau cuộc gọi, gửi tóm tắt về <code>{baseUrl}/customers/:contact_id/call-summaries</code>.</li>
                    </ol>
                    <div style={{ fontWeight: 600, marginBottom: 8 }}>cURL mẫu</div>
                    <pre style={{ margin: 0, whiteSpace: 'pre-wrap', wordBreak: 'break-all' }}>{curlExamples.list}</pre>
                </div>

                <Modal
                    visible={docsVisible}
                    onCancel={this.closeDocs}
                    footer={null}
                    width={900}
                    bodyStyle={{ maxHeight: '75vh', overflowY: 'auto' }}
                    title="Tài liệu tích hợp cho bên thứ 3"
                >
                    <div style={{ display: 'grid', gap: 16 }}>
                        <Alert
                            type="info"
                            showIcon
                            message="Mọi request đều phải gửi x-api-key. Tài liệu này đang được bundle trực tiếp ở frontend, không còn gọi API docs từ backend."
                        />

                        {docsUpdatedAt ? (
                            <div style={{ fontSize: 13, color: '#888' }}>
                                Tài liệu cập nhật lúc: {docsUpdatedAt}
                            </div>
                        ) : null}

                        <div>
                            <div style={{ fontWeight: 600, marginBottom: 8 }}>Luồng kết nối</div>
                            <ol style={{ paddingLeft: 18, marginBottom: 0 }}>
                                <li>CRM tạo API key cho công ty.</li>
                                <li>Hệ thống bên thứ 3 lưu API key và dùng làm header auth.</li>
                                <li>Gọi API danh sách khách hàng để đồng bộ dữ liệu.</li>
                                <li>Gọi API chi tiết để lấy thêm <code>memory_summary</code> và <code>semantic_memory</code>.</li>
                                <li>Gọi API lịch sử hội thoại để lấy batch mới nhất và dùng <code>before_timestamp</code> + <code>before_key</code> để load thêm tin cũ.</li>
                                <li>Gọi API <code>POST /customers/:contact_id/call-summaries</code> để đẩy text tóm tắt sau cuộc gọi về CRM.</li>
                                <li>Khi lộ key, thu hồi và tạo lại key mới tại màn này.</li>
                            </ol>
                        </div>

                        <div>
                            <div style={{ fontWeight: 600, marginBottom: 8 }}>Endpoint</div>
                            <pre style={{ margin: 0, whiteSpace: 'pre-wrap', wordBreak: 'break-all' }}>{`GET ${baseUrl}/customers?page=1&limit=20\nGET ${baseUrl}/customers/:contact_id\nGET ${baseUrl}/customers/:contact_id/messages?limit=20\nPOST ${baseUrl}/customers/:contact_id/call-summaries\nHeader: x-api-key: YOUR_API_KEY`}</pre>
                        </div>

                        <div>
                            <div style={{ fontWeight: 600, marginBottom: 8 }}>cURL mẫu - danh sách</div>
                            <pre style={{ margin: 0, whiteSpace: 'pre-wrap', wordBreak: 'break-all' }}>{curlExamples.list}</pre>
                        </div>

                        <div>
                            <div style={{ fontWeight: 600, marginBottom: 8 }}>cURL mẫu - chi tiết</div>
                            <pre style={{ margin: 0, whiteSpace: 'pre-wrap', wordBreak: 'break-all' }}>{curlExamples.detail}</pre>
                        </div>

                        <div>
                            <div style={{ fontWeight: 600, marginBottom: 8 }}>cURL mẫu - lịch sử hội thoại</div>
                            <pre style={{ margin: 0, whiteSpace: 'pre-wrap', wordBreak: 'break-all' }}>{curlExamples.history}</pre>
                        </div>

                        <div>
                            <div style={{ fontWeight: 600, marginBottom: 8 }}>cURL mẫu - load more hội thoại</div>
                            <pre style={{ margin: 0, whiteSpace: 'pre-wrap', wordBreak: 'break-all' }}>{curlExamples.historyLoadMore}</pre>
                        </div>

                        <div>
                            <div style={{ fontWeight: 600, marginBottom: 8 }}>cURL mẫu - gửi tóm tắt cuộc gọi</div>
                            <pre style={{ margin: 0, whiteSpace: 'pre-wrap', wordBreak: 'break-all' }}>{curlExamples.importCallSummary}</pre>
                        </div>

                        <div>
                            <div style={{ fontWeight: 600, marginBottom: 8 }}>Swagger / OpenAPI mẫu</div>
                            <Input.TextArea readOnly value={swaggerExample} autoSize={{ minRows: 18, maxRows: 28 }} />
                        </div>

                        {markdownDoc ? (
                            <div>
                                <div style={{ fontWeight: 600, marginBottom: 12 }}>Tài liệu tích hợp</div>
                                <div
                                    style={{
                                        border: '1px solid #f0f0f0',
                                        borderRadius: 8,
                                        padding: 16,
                                        background: '#fff'
                                    }}
                                >
                                    <ReactMarkdown
                                        source={markdownDoc}
                                        linkTarget="_blank"
                                    />
                                </div>
                            </div>
                        ) : null}
                    </div>
                </Modal>
            </div>
        );
    }
}
